export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f2a62595a9886ecfab298d22488c09be4f5ca66be&name=fetchTypeahead!'